export default {
    data: function () {
        return {
            beforeUnloadHandlerAdded: false, // track if handler is added
            routeLeaveModalCallback: null,
            isClosingRouteLeaveModal: false, // prevent recursion
        }
    },
    methods: {
        addBeforeUnloadHandler() {
            if (!this.beforeUnloadHandlerAdded) {
                window.addEventListener(
                    'beforeunload',
                    this.beforeUnloadHandler
                )
                this.beforeUnloadHandlerAdded = true
            }
        },
        removeBeforeUnloadHandler() {
            if (this.beforeUnloadHandlerAdded) {
                window.removeEventListener(
                    'beforeunload',
                    this.beforeUnloadHandler
                )
                this.beforeUnloadHandlerAdded = false
            }
        },
        beforeUnloadHandler(event) {
            event.preventDefault()
            event.returnValue = ''
            // Custom messages are ignored by most browsers.
            return ''
        },
        // canceld means user wants to cancel test, not cancel leave-action
        routeLeaveModalCancelled() {
            if (this.isClosingRouteLeaveModal) return;
            this.isClosingRouteLeaveModal = true;
            if (this.routeLeaveModalCallback) {
                this.routeLeaveModalCallback(true);
                this.routeLeaveModalCallback = null;
            }
            const modal = this.$refs.routeLeaveModal;
            if (modal && typeof modal.close === 'function') {
                modal.close();
            }
            this.isClosingRouteLeaveModal = false;
        },
        routeLeaveModalConfirmed() {
            if (this.isClosingRouteLeaveModal) return;
            this.isClosingRouteLeaveModal = true;
            if (this.routeLeaveModalCallback) {
                this.routeLeaveModalCallback(false);
                this.routeLeaveModalCallback = null;
            }
            const modal = this.$refs.routeLeaveModal;
            if (modal && typeof modal.close === 'function') {
                modal.close();
            }
            this.isClosingRouteLeaveModal = false;
            
        },
    },
}
